module.exports = __webpack_public_path__ + "img/charging-station-infographic-fr.a162e26c.webp";